import React from 'react';

const EconomicalScoreTrackerPlayer = ({ imgSrc, score, unit = '€' }) => {
	const scoreSign = Math.sign(score);
	let scoreColor;
	let imgElement;
	let unitScore;

	if (scoreSign === 1) {
		scoreColor = 'green'
	} else if (scoreSign === -1) {
		scoreColor = 'red'
	} else {
		scoreColor = 'orange'
	}

	if (typeof imgSrc === 'string') {
		imgElement= <img src={imgSrc} className={'eco-score-tracker__player-img'} />;
	} else {
		imgElement = imgSrc;
	}

	if (unit === '$' || unit === '€') {
		unitScore = `${unit}${score}`;
	} else {
		unitScore = `${score}${unit}`;
	}

	return (
		<div className={'eco-score-tracker-player-wrap'}>

			<div className={'eco-score-tracker__player-img__wrap'}>
				{imgElement}
			</div>

			<div className={`score-result score-result--${scoreColor}`}>
				{unitScore}
			</div>
		</div>
	)
}

export { EconomicalScoreTrackerPlayer }
